import { render } from "./text-column.vue?vue&type=template&id=017b759e&scoped=true"
import script from "./text-column.vue?vue&type=script&lang=js"
export * from "./text-column.vue?vue&type=script&lang=js"

import "./text-column.vue?vue&type=style&index=0&id=017b759e&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\montalvo.ti\\front-on\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-017b759e"]])

export default __exports__